import DOMPurify from 'dompurify';
import React, { HTMLAttributes, ReactElement, ReactHTML } from 'react';

/**
 *
 * @param text Texto a ser substituído (pode incluir HTML).
 * \*NEGRITO\*, \__ITÁLICO_\_, \~TACHADO\~.
 * #N# Para os N replacers
 * @param replacers N Replacers do texto
 * @returns SPAN FORMATADA
 */
export function getFormattedText<T extends keyof ReactHTML = keyof ReactHTML>(
  text: string | { text: string; tag?: T; props?: HTMLAttributes<T> },
  ...replacers: string[]
): ReactElement {
  let final = typeof text === 'string' ? text : text.text;
  const tag = typeof text === 'string' ? 'span' : text.tag ?? 'span';
  const props = typeof text === 'string' ? {} : text.props ?? {};

  // 1º: Fazer o replace dos argumentos
  replacers.forEach((s, i) => {
    final = final.replaceAll(`#${i + 1}#`, s);
  });
  // 2º: Itálico
  final = final
    .replaceAll(/_([^_]*)_/g, '<i>$1</i>')
    // 3º: Negrito
    .replaceAll(/\*([^*]*)\*/g, '<b>$1</b>')
    // 4º: Tachado
    .replaceAll(/~([^~]*)~/g, '<del>$1</del>');

  return React.createElement(tag, {
    dangerouslySetInnerHTML: { __html: DOMPurify.sanitize(final) },
    ...props,
  });
}
